import { Config } from "../config/Config";

export class OAuthClient {
    private clientId: string;
    private redirectUri: string;
    private authUrl: string;
    private tokenUrl: string;
    private registerUrl: string;
    private state: string;
    private codeVerifier: string;
  
    constructor(clientId: string, redirectUri: string, authUrl: string, tokenUrl: string, registerUrl: string) {
      this.clientId = clientId;
      this.redirectUri = redirectUri;
      this.authUrl = authUrl;
      this.tokenUrl = tokenUrl;
      this.registerUrl = registerUrl;
      this.state = this.generateState();
      this.codeVerifier = this.generateCodeVerifier();
    }
  
    generateState() {
        return Math.random().toString(36).substring(7);
    }

    generateCodeVerifier() {
        // const array = new Uint32Array(56 / 2);
        const array = new Uint32Array(64 / 2);
        window.crypto.getRandomValues(array);
        return Array.from(array, dec => ('0' + dec.toString(16)).substr(-2)).join('');
    }

    async generateCodeChallenge(verifier:string) {
        // const data = new TextEncoder().encode(verifier);
        // const digest = await window.crypto.subtle.digest('SHA-256', data);
        // return btoa(String.fromCharCode(...new Uint8Array(digest)))
        //     .replace(/\+/g, '-')
        //     .replace(/\//g, '_')
        //     .replace(/=+$/, '');

        //this.codeVerifier = this.generateCodeVerifier();
        const data = new TextEncoder().encode(verifier);
        // const hash = await crypto.subtle.digest('SHA-256', data);
        // const bytes = new Uint8Array(hash);
        // let binary = "";
        // for (let i = 0; i < bytes.byteLength; i++) {
        //     binary += String.fromCharCode(bytes[i]);
        // }

        // return btoa(binary)
        //     .replace(/\+/g, "-")
        //     .replace(/\//g, "_")
        //     .replace(/=+$/, "");
        const digest = await crypto.subtle.digest("SHA-256", data);

        // richtiges Base64 erzeugen:
        const base64 = btoa(String.fromCharCode(...new Uint8Array(digest)));

        // zu base64url machen:
        return base64.replace(/\+/g, "-")
                    .replace(/\//g, "_")
                    .replace(/=+$/, "");
    }
    
    setCookie(name:string, value:string, days:number) {
        const d = new Date();
        d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = "expires=" + d.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }
    
    getCookie(name:string) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts && parts.length === 2) {
            let part = parts.pop();
            if(part) {
                return part.split(';').shift();
            }
            else {
            }
        }
    }

    public async login() {
        const codeChallenge = await this.generateCodeChallenge(this.codeVerifier);
        const url = `${this.authUrl}?response_type=code&client_id=${this.clientId}&redirect_uri=${encodeURIComponent(this.redirectUri)}&scope=read&state=${this.state}&code_challenge=${codeChallenge}&code_challenge_method=S256`;
        localStorage.setItem('oauth_state', this.state);
        this.setCookie('code_verifier', this.codeVerifier, 10);
        window.location.href = url;
    }

    public register() {
        const url = `${this.registerUrl}?response_type=code&client_id=${this.clientId}&redirect_uri=${encodeURIComponent(this.redirectUri)}&scope=read&state=${this.state}`;
        window.location.href = url;
    }
  
    public async handleCallback() {
        /*
      const hash = window.location.hash.substr(1);
      const result = hash.split('&').reduce((res, item) => {
        const parts = item.split('=');
        res[parts[0]] = parts[1];
        return res;
      }, {} as Record<string, string>);
  
      if (result.access_token) {
        localStorage.setItem('access_token', result.access_token);
      }
        */
    
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const state = urlParams.get('state');

      const savedState = localStorage.getItem('oauth_state');
      const codeVerifier = this.getCookie('code_verifier');


      if (state !== savedState) {
          console.error('Invalid state');
          return;
      }
      
      if(code == null) {
        console.error("no code for accesstoken found");
        return;
      }
      if(codeVerifier == null) {
        console.error("no codeVerifier for accesstoken found");
        return;
      }

      const response = await this.requestAccessToken(code, codeVerifier);
      if (!response) {
        console.error('Error fetching access token');
      }
    }
  
    async requestAccessToken(code:string, codeVerifier:string) {
        const response = await fetch(this.tokenUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                code: code,
                code_verifier: codeVerifier,
                // OAuth requires the token exchange to carry the SAME redirect_uri as the
                // authorize step. Without this, PortalBackend substitutes its server-configured
                // one - which only matches when the frontend runs on the canonical stage/prod
                // domain, and breaks e.g. localhost logins against stage (400 "redirect_uri is
                // invalid"). Validation against the client's allowlist stays with LoginWithSengi.
                redirect_uri: this.redirectUri
            })
        });

        if (!response.ok) {
            console.error('Error response:', await response.text());
            throw new Error('Token request failed');
        }

        const data = await response.json();
        localStorage.setItem('access_token', data.accessToken);
        localStorage.removeItem('oauth_state');
        document.cookie = "code_verifier=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.href = '/chat';
        return true;
    }

    public getAccessToken() {
      return localStorage.getItem('access_token');
    }

    deleteAccessToken() {
        localStorage.removeItem('access_token');
        this.updateTokenStatus();
    }

    public async checkTokenValidity() : Promise<boolean> {
        const token = this.getAccessToken();
        if (token) {
            try {
                const response = await fetch('http://localhost:4000/secure', {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                const data = await response.json();
                if (response.ok) {
                    //console.log('Token is valid:', data);
                    //alert('Token is valid');
                    return true;
                } else {
                    //console.error('Token is invalid:', data);
                    //alert('Token is invalid');
                    return false;
                }
            } catch (error) {
                //console.error('Error checking token validity:', error);
                //alert('Error checking token validity');
                return false;
            }
        } else {
            //alert('No access token found');
            return false;
        }
    }
    
    async validateTokenWithSecondService() {
        const token = this.getAccessToken();
        if (token) {
            try {
                const response = await fetch(Config.json.BackendUrl+'/v1/auth/validatetoken', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ accessToken: token })
                });
                const data = await response.json();
                if (response.ok) {
                    return true;
                } else {
                    console.error('Token validation failed with second service:', data);
                    return false;
                }
            } catch (error) {
                console.error('Error validating token with second service:', error);
                return false;
            }
        } else {
            return false;
        }
    }

    updateTokenStatus() {
        const token = this.getAccessToken();
    }

    logout() {
        this.deleteAccessToken();
    }
  }

  /*
if(!process.env.OAUTH_CLIENT_ID || 
    !process.env.REDIRECT_URI || 
    !process.env.AUTH_URL || 
    !process.env.TOKEN_URL || 
    !process.env.REGISTER_URL ) {
    
    throw Error("missing .env data!");
}

*/


//export const oauthClient = new OAuthClient("sengilabs", "http://localhost:3000/login", "http://localhost:4000/login", "http://localhost:23100/v1/auth/requestaccesstoken", "http://localhost:4000/register");
export const oauthClient = new OAuthClient(Config.json.OauthClientId, Config.json.RedirectUrl, Config.json.AuthUrl, Config.json.TokenUrl, Config.json.RegisterUrl);

